import { Component } from '@angular/core';
import { LoaderService } from 'src/app/core/services/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  constructor(private readonly loaderService: LoaderService) {}

  public getIsLoading(): boolean {
    return this.loaderService.isLoading;
  }

}
